module.exports = __webpack_public_path__ + "static/img/fastport.409c38d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/fastport.png
// module id = O6QM
// module chunks = 44